import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Blletiket } from './../../../providers/bll/bll-etiket';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the EtiketlistesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-etiketlistesi',
  templateUrl: 'etiketlistesi.html',
})
export class EtiketlistesiPage {
  etiketListesi:any=[];
  onaylaPasif: boolean = false;

  constructor(public navCtrl: NavController,
    public viewCtrl:ViewController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {

    this.EtiketDetayListesi_Temp();
    
  }
  kapat(){
    this.viewCtrl.dismiss();
  }
  EtiketDetayListesi_Temp() {
    var blletiket = new Blletiket();
    blletiket.getAll().then(a => {
      var sonuc = <any>a;
      this.etiketListesi = sonuc;

if(sonuc==length>0)
 {
   this.onaylaPasif=true;
 }
    })

  }
  cacheTemizle() {
   
    var blletiket = new Blletiket();
    blletiket.execRawQuery("DELETE FROM Rafetiket ").then(b => {
      this.EtiketDetayListesi_Temp();
      //this.onaylaPasif = true;
    }).catch(x => {
    
    })
  }
  etiketSil(etikets) {

      var blletiket= new Blletiket();
      blletiket.delete(etikets).then(a => {
        this.EtiketDetayListesi_Temp();
      }).catch(x => {
      
      })
    
  }
 
    kaydet() {
      this.onaylaPasif=true;
      var etiketID = -1;
      var blletiket = new Blletiket();
      blletiket.getAll().then(a => {
        var formData = new FormData();
        
        formData.append("asd", JSON.stringify(a));
       
        this.bllOrtak.islem(formData, "TopluRafEtiketGonder", "", false).then(a => {
          blletiket.execRawQuery("DELETE FROM RafEtiket WHERE Id="+etiketID).then(b => {
          
         this.EtiketDetayListesi_Temp();
         this.ortak.showBasicAlert("Başarılı","Etiketler Basım İçin Gönderildi");
         
          })
          
        })
        this.viewCtrl.dismiss();
      }).catch(x => {
       this.onaylaPasif=false;
       this.ortak.showBasicAlert("Hata","İşlem Yapılamadı");
      })
    }

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/etiketlistesi/etiketlistesi.ts